import React, { useEffect, useState } from "react";
import HomeContent from "./HomeContent";
import Welcome from "./Welcome";

const Home = () => {
  const [data, setData] = useState([]);
  const [lat, setLat] = useState();
  const [long, setLong] = useState();
  const [city, setCity] = useState();
  const [country, setCountry] = useState();

  const [method, setMethod] = useState("");
  const [shafaq, setShafaq] = useState("");
  const [school, setSchool] = useState("");
  const [midnightMode, setMidnightMode] = useState("");
  const [latitudeMethod, setLatitudeMethod] = useState("");

  let manage = {
    setMethod,
    setShafaq,
    setSchool,
    setMidnightMode,
    setLatitudeMethod,
    method,
  };

  const getUserLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      setLat(position.coords.latitude);
      setLong(position.coords.longitude);
    });
  };

  useEffect(() => {
    if (lat === undefined || long === undefined) return;

    const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${long}&localityLanguage=en`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data.city) setCity(data.city);
        if (data.countryName) setCountry(data.countryName);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [lat, long]);

  useEffect(() => {
    const query = `&method=${method}&shafaq=${shafaq}&school=${school}&midnightMode=${midnightMode}&latitudeAdjustmentMethod=${latitudeMethod}`;

    const url = `https://api.aladhan.com/v1/timingsByCity?city=${city}&country=${country}${query}`;

    city !== undefined &&
      country !== undefined &&
      fetch(url)
        .then((res) => res.json())
        .then((out) => {
          setData(out.data);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [city, country, method, shafaq, school, midnightMode, latitudeMethod]);

  if (data.length !== 0) {
    return (
      <HomeContent
        data={data}
        location={`${city}, ${country}`}
        setLat={setLat}
        setLong={setLong}
        getUserLocation={getUserLocation}
        manage={manage}
      />
    );
  } else {
    return (
      <Welcome
        setLat={setLat}
        setLong={setLong}
        getUserLocation={getUserLocation}
        manage={manage}
      />
    );
  }
};

export default Home;
